import { render } from "@/assets/templates/CVEView.html?vue&type=template&id=d8a2586a&scoped=true&external"
import script from "./CVEView.vue?vue&type=script&lang=js"
export * from "./CVEView.vue?vue&type=script&lang=js"

import "@/assets/css/CVEView.css?vue&type=style&index=0&id=d8a2586a&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8a2586a"]])

export default __exports__